import { render } from "./notificationDetailed.vue?vue&type=template&id=822b6382"
import script from "./notificationDetailed.vue?vue&type=script&lang=js"
export * from "./notificationDetailed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__